<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/W4GqGU/tc-custom/9781627884952.jpg?1705120718535" alt="This image is the cover for the book Flying Warbirds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Flying Warbirds
      </h1>
      <p class="bookDescription body article font2">
        <p>Get a comprehensive look at how World War II was fought from the air.Do you want to get an up-close look at some of the rarest airplanes in the world? Are you curious about combat aircraft from World War II? In deluxe hard-back volumes, Flying Warbirds brings U.S., British, German, Russian and Japanese fighting planes from the 1930s and 1940s together, complete with detailed photographs to delight every aeronautics connoisseur.The airplanes at the Flying Heritage Collection were created at a time when aeronautical discovery had evolved to aviation mastery. Finely crafted by distinguished design bureaus with the leading technologies of the 1930s and 1940s, the main emphasis of the collection includes combat aircraft from World War II.In 1998, Paul G. Allen began acquiring and preserving these iconic warriors and workhorses, many of which are the last of their kind. Allen's passion for aviation and history, and his awareness of the increasing rarity of original WWII aircraft, motivated him to restore these artifacts to the highest standard of authenticity.Periodically, one or more of the exhibits are temporarily absent to participate in an event, for maintenance, or for continuing restoration. Experience one of the world’s top airplane collections any time you like through Flying Warbirds.Photographs include cockpit shots, exterior museum shots, historic photographs, and breathtaking contemporary flying shots from photographers like award-winning John Dibbs. Flying Warbirds is the definitive guide to everything you want to know about this fascinating period in aeronautics and military history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cory Graff
      </h2>
      
      <p class="authorDescription body article">Cory Graff is the Military Aviation Historian at the Flying Heritage Collection museum in Everett, Washington. In his free time, he works on aviation-related history projects, including exhibits and books. His articles have been published in Air & Space Smithsonian magazineand the Museum of Flight's Aloft magazine. Graff is the author of five previous aviation books, including Shot to Hell: The Stories and Photos of Ravaged WWII Warbirds, Strike and Return: American Air Power and the Fight for Iwo Jima, and P-47 Thunderbolt at War. He lives in Seattle, Washington.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zenith Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e6169cd